import ApplyAttributes from "Components/ApplyAttributes/ApplyAttributes";
import AutomaticallyListedAttributes from "Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import LoadingIndicator from "Components/LoadingIndicator/LoadingIndicator";
import Panel from "Components/Panel/Panel";
import PanelListDefault from "Components/PanelListDefault/PanelListDefault";
import ResetVariables from "Components/ResetVariables/ResetVariables";
import React, { useEffect, useState } from "react";

const RevenueCompanyList = ({
    costDayIdSelecteds,
    updating,
    showNewRevenueMonthPanel,
    updatePanelCostSpreadsheet,
    onUpdateInsertRevenue,
    onUpdatePanelCostSpreadsheet,
    onUpdating,
    onUpdateReloadSalaryBenefitsCost,
    itemInValidation
}) => {
    const [idRevenueSelected, setIdRevenueSelected] = useState(null)
    const [productCode, setProductCode] = useState(null)
    const [dsProduct, setDsProduct] = useState(null)
    const [productionOrder, setProductionOrder] = useState(null)
    const [pricePerPiece, setPricePerPiece] = useState(null)
    const [quantityPieces, setQuantityPieces] = useState(null)
    const [valuePerMinute, setValuePerMinute] = useState(null)
    const [totalValue, setTotalValue] = useState(null)
    const [dateReceived, setDateReceived] = useState(null)
    const [dateRealReturn, setDateRealReturn] = useState(null)
    const [statusId, setStatusId] = useState(null)
    const [status, setStatus] = useState(null)
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);

    const [revenueIdSelecteds, setRevenueIdSelecteds] = useState([])
    const [revenuesListByIdRevenue, setRevenuesListByIdRevenue] = useState(null)

    const [loadRevenuesMonthPanel, setLoadRevenuesMonthPanel] = useState(null);
    const [loadRevenuesEmployeeList, setLoadRevenuesEmployeeList] = useState(false);
    const [revenueListDetail, setRevenueListDetail] = useState(null);

    const attributeList = [
        { name: "id", value: idRevenueSelected, setter: setIdRevenueSelected, allowsMultipleRecordsSelected: true },
        { name: "productCode", value: productCode, setter: setProductCode },
        { name: "dsProduct", value: dsProduct, setter: setDsProduct },
        { name: "productionOrder", value: productionOrder, setter: setProductionOrder },
        { name: "pricePerPiece", value: pricePerPiece, setter: setPricePerPiece },
        { name: "quantityPieces", value: quantityPieces, setter: setQuantityPieces },
        { name: "valuePerMinute", value: valuePerMinute, setter: setValuePerMinute },
        { name: "totalValue", value: totalValue, setter: setTotalValue },
        { name: "dateReceived", value: dateReceived, setter: setDateReceived },
        { name: "dateRealReturn", value: dateRealReturn, setter: setDateRealReturn },
        { name: "statusId", value: statusId, setter: setStatusId },
        { name: "status", value: status, setter: setStatus },
        { name: "username", value: username, setter: setUsername, readOnly: 'S' },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate, readOnly: 'S' },
    ];

    const setRevenuesList = async (costDayIdSelected) => {
        const parameters = {
            supplierId: costDayIdSelected,
            selectedMonth: itemInValidation.currentMonth
        }
        const revenueProductionsList = await ExecuteAxios.api('get', '/production/get-production-grid-selected-supplier/', { params: parameters });
        setRevenuesListByIdRevenue(revenueProductionsList)

        if (!costDayIdSelected || costDayIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    }

    useEffect(() => {
        setLoadRevenuesEmployeeList(false)
        if (costDayIdSelecteds || costDayIdSelecteds.length === 1) {
            setRevenuesList(costDayIdSelecteds[0])
        } else {
            setRevenuesList(null)
        }
    }, [costDayIdSelecteds, showNewRevenueMonthPanel, updating === false, loadRevenuesEmployeeList === true])

    function getListRevenuesByIdUser() {
        if (!updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setRevenueIdSelecteds}
                    idsSelected={revenueIdSelecteds}
                    data={revenuesListByIdRevenue}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={revenueListDetail}
                    attributeList={attributeList}
                    readOnlyAttributes={true}
                />
            )
        }
    }

    const setRevenuesAttributesDetail = async (revenueIdSelected) => {
        const parameters = { id: revenueIdSelected }
        const revenueMonth = await ExecuteAxios.api('get', `/production/get-production-detail-selected-supplier/`, { params: parameters })
        setRevenueListDetail(revenueMonth)
        if (revenueMonth) {
            ApplyAttributes.applyAttributes(revenueMonth, attributeList)
        }

        if (!revenueIdSelected || revenueIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (revenueIdSelecteds && revenueIdSelecteds.length === 1) {
            setRevenuesAttributesDetail(revenueIdSelecteds[0]);
        } else {
            setRevenuesAttributesDetail(null);
        }
    }, [revenueIdSelecteds, updating]);

    const costDayStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        zIndex: '0'
    }

    return (
        <LoadingIndicator loaded={!loadRevenuesMonthPanel}>
            <Panel titlePage={null}
                style={costDayStyle}
                canViewCRUD={true}
                setInserting={onUpdateInsertRevenue}
                enableNewRecord={null}
                canNewRecord={!showNewRevenueMonthPanel}
                updating={updating}
                inserting={false}
                enableDelete={null}
                canDelete={null}
                deleteFunction={null}
                recordsSelected={revenueIdSelecteds}
                setUpdating={onUpdating}
                putFunction={null}
                canEdit={revenueIdSelecteds && revenueIdSelecteds.length === 1}
                enableEdit={true}
                canSaveAfterEdit={false}
                updateNameButton={'Visualizar'}
                cancelNameButton={'Fechar'}
                dataListedAttributes={revenueListDetail}
                attributeList={attributeList}
            >
                {getListRevenuesByIdUser()}
            </Panel>
        </LoadingIndicator>
    )
}

export default RevenueCompanyList;